// extracted by mini-css-extract-plugin
module.exports = {"containerBg":"HomePage_containerBg__1v96d","outerContainer":"HomePage_outerContainer__3fxwv"};